import { render } from "./index.vue?vue&type=template&id=675b24b6"
import script from "./notifications.ts?vue&type=script&lang=js"
export * from "./notifications.ts?vue&type=script&lang=js"

import "./notifications.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script